"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CriticalButton = CriticalButton;
const components_1 = require("@alcumus/components");
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const useStyles = (0, core_1.makeStyles)(() => ({
    buttonBase: {
        borderRadius: 100,
        padding: '10px 24px',
    },
    buttonText: {
        fontWeight: components_1.StyleVariables.fonts.weight.semiBold,
        lineHeight: components_1.StyleVariables.fonts.lineHeight.h5,
    },
    root: {
        backgroundColor: components_1.StyleVariables.colors.text.critical,
        color: components_1.StyleVariables.colors.white,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: components_1.StyleVariables.colors.action.critical.hover,
        },
        '&:active': {
            backgroundColor: components_1.StyleVariables.colors.action.critical.pressed,
        },
        '&:disabled': {
            opacity: 0.3,
            backgroundColor: components_1.StyleVariables.colors.text.critical,
            color: components_1.StyleVariables.colors.white,
        },
    },
}));
function CriticalButton({ text, ariaLabel, onClick, disabled = false, }) {
    const classes = useStyles();
    return (react_1.default.createElement(components_1.Button, { "aria-label": ariaLabel, uppercase: false, rounded: true, className: classes.buttonBase, size: "medium", disabled: disabled, "data-testid": "criticalButton", classes: {
            root: classes.root,
        }, onClick: (e) => onClick && onClick(e) },
        react_1.default.createElement(components_1.Text, { center: true, className: classes.buttonText }, text)));
}
